import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchExcursionMedicalConditions = async (
  { rootGetters, commit },
  { excursionId, params, queryParams }
) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);
  const response = await stbApi.getExcursionMedicalConditions(excursionId, params, queryParams);

  return response;
};
